import { createContext, useState } from 'react'

export const HeaderContext = createContext()

const HeaderContextProvider = ({ children }) => {
  const [customHeaderContent, setCustomHeaderContent] = useState()

  return (
    <HeaderContext.Provider
      value={{ value: customHeaderContent, set: setCustomHeaderContent }}
    >
      {children}
    </HeaderContext.Provider>
  )
}

export default HeaderContextProvider
